import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class NotificationModel extends BaseModel {

    constructor() {
        super({
                name: "notification",
                tableName: 'notification',
                label: "Danh Sách Thông Báo",
                display_key: 'name',
                default_order: { key: 'updated_at', direction: 'asc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                reciever_type: {
                    name: 'reciever_type',
                    type: "Selection",
                    label: 'Người nhận',
                    custom: 'SelectionText',
                    options: [
                        { value: '1', label: 'Tất cả người dùng' },
                        { value: '2', label: 'Tất cả trang trại'},
                        { value: '3', label: 'Người dùng'},
                        { value: '4', label: 'Trang trại'}
                    ],
                    filter: {
                        type: 'select', 
                        optionLabel: 'label', 
                        optionKey: 'value', 
                        match: 'equals' 
                    }
                    // computed: (data) => {
                    //     data.reciever = "";
                    // }
                },
                title: {
                    name: 'title',
                    type: "String",
                    label: 'Tiêu đề'
                },
                short_content: {
                    name: 'short_content',
                    type: "String",
                    label: 'Mô tả ngắn'
                },
                content: {
                    name: 'content',
                    type: "String",
                    display: false
                },
                created_at: {
                    name: 'created_at',
                    type: "DateTime",
                    label: 'Ngày tạo',
                    filter: {
                        type: 'DateRange',
                        match: 'range'
                    }
                },
                recievers: {
                    refs: 'recievers {user {id fullname farm_id}}',
                    display: false
                },
                notification_farm: {
                    refs: 'notification_farm {farm {id name}}',
                    display: false
                }
            },
            )
    }

}